// 自定义指令
import Vue from 'vue'

//为空显示--
Vue.filter("empty", value => {
  value = trimRight(trimLeft(value));
  if (
    value === "" ||
    JSON.stringify(value) === "undefined" ||
    JSON.stringify(value) === "null" ||
    JSON.stringify(value) === "NaN"
  ) return "--";
  return value;

  function trimLeft(s) {
    if (s == null) {
      return "";
    }
    var whitespace = new String(" \t\n\r");
    var str = new String(s);
    if (whitespace.indexOf(str.charAt(0)) != -1) {
      var j = 0,
        i = str.length;
      while (j < i && whitespace.indexOf(str.charAt(j)) != -1) {
        j++;
      }
      str = str.substring(j, i);
    }
    return str;
  }

  //去掉右边的空白 www.2cto.com   
  function trimRight(s) {
    if (s == null) return "";
    var whitespace = new String(" \t\n\r");
    var str = new String(s);
    if (whitespace.indexOf(str.charAt(str.length - 1)) != -1) {
      var i = str.length - 1;
      while (i >= 0 && whitespace.indexOf(str.charAt(i)) != -1) {
        i--;
      }
      str = str.substring(0, i + 1);
    }
    return str;
  }
})

//数字格式化
Vue.filter('number', (value, fixed, seat = true) => {
  let reg = /^[+-]?[\d]+([.][\d]*)?([Ee][+-]?[\d]+)?$/;
  if (!reg.test(value)) return "0";
  if (isNaN(fixed)) fixed = 0;
  value = getFullNum(value);
  value = getThousandNumber(value, fixed);
  return value;

  function getFullNum(num) {
    //处理非数字
    if (isNaN(num)) {
      return num
    };
    //处理不需要转换的数字
    let str = '' + num;
    str = str.toLocaleLowerCase();
    if (!/e/i.test(str)) {
      return num;
    };
    //判断正负
    let number = str.split("e")[0];
    let symbol = str.split("e")[1];
    // console.log(str,number,symbol)
    // //先获取到精确的小数位
    let fixed = ('' + num).match(/\d+$/)[0];
    if (parseInt(symbol) < 0) {
      let cc = 1;
      if (number.indexOf(".") > -1) {
        cc = number.split(".")[1].length;
      } else {
        cc = number.length;
      }
      return new Number(num).toFixed(parseInt(fixed) + cc);
    } else {
      return new Number(num).toFixed(0);
    }
  }

  function getThousandNumber(number, fixed) {
    if (seat) {
      number = parseFloat(number).toFixed(fixed);
    } else {
      number = Number(parseFloat(number).toFixed(fixed)) + "";
    }
    let num = number;
    let points = "";
    if (number.indexOf(".") > -1) {
      num = number.split(".")[0];
      points = number.split(".")[1];
    }
    let counter = 0;
    let result = "";
    for (var i = num.length - 1; i >= 0; i--) {
      counter++;
      result = num.charAt(i) + result;
      if (!(counter % 3) && i != 0) {
        result = ',' + result;
      }
    }
    if (points != "") {
      return result + "." + points;
    } else {
      return result;
    }
  }
})

Vue.filter('numberf', function (value, fixed = 2) {
  let reg = /^[+-]?[\d]+([.][\d]*)?([Ee][+-]?[\d]+)?$/;
  if (!reg.test(value)) return 0;
  let resut = Number(parseFloat(value).toFixed(fixed));
  return resut;
})

// 数字加千分位符号
Vue.filter('currencyKb', function (num) {
  if (num) {
    num = num.toString().replace(/\$|\,/g, '');
    if (isNaN(num))
      num = "0";
    let sign = (num == (num = Math.abs(num)));
    num = Math.floor(num * 100 + 0.50000000001);
    let cents = num % 100;
    num = Math.floor(num / 100).toString();
    if (cents < 10)
      cents = "0" + cents;
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
      num = num.substring(0, num.length - (4 * i + 3)) + ',' +
        num.substring(num.length - (4 * i + 3));
    return (((sign) ? '' : '-') + num + '.' + cents);
  }
});

Vue.filter('currencyWy', function (num, type) {
  if (type == 'number') {
    return Number((num / 10000).toFixed(4)) + " 万元"
  }
  if (num) {
    return Number((num / 10000).toFixed(4)) + " 万元"
  } else {
    return "0 万元"
  }
});

//百分数
Vue.filter('percent', (value, multiple, fixed) => {
  let reg = /^[+-]?[\d]+([.][\d]*)?([Ee][+-]?[\d]+)?$/;
  if (!reg.test(value)) return value;
  if (isNaN(fixed)) fixed = 2;
  if (isNaN(multiple)) multiple = 1;
  value = multiple * value;
  value = Vue.filter("number")(value, fixed);
  return Number(value) + "%";
})

//首字大写
Vue.filter('capitalize', (value) => {
  var i, ss = value.toLowerCase().split(/\s+/);
  for (i = 0; i < ss.length; i++) {
    ss[i] = ss[i].slice(0, 1).toUpperCase() + ss[i].slice(1);
  }
  return ss.join(' ');
})

//字母大写
Vue.filter('uppercase', (value) => {
  return value.toUpperCase();
})

//字母小写
Vue.filter('lowercase', (value) => {
  return value.toLowerCase();
})

//查询身份证性别
Vue.filter('sex', (value) => {
  var name = "";
  switch (value) {
    case 0: name = "--"; break;
    case 1: name = "男"; break;
    case 2: name = "女"; break;
    default: name = "";
  }
  return name;
})

//根据身份证获取年龄
Vue.filter('age', (value) => {
  if (!value) {
    return "";
  }
  //获取年龄
  var myDate = new Date();
  var month = myDate.getMonth() + 1;
  var day = myDate.getDate();
  var age = myDate.getFullYear() - value.substring(6, 10) - 1;
  if (value.substring(10, 12) < month || value.substring(10, 12) == month && value.substring(12, 14) <= day) {
    age++;
  }
  return age;
})

//platfrom
Vue.filter('platform', (value) => {
  var platform = "";
  switch (value) {
    case "ms": platform = "管理端"; break;
    case "pc": platform = "客户端"; break;
    case "mb": platform = "手机端"; break;
    default: platform = "其他";
  }
  return platform;
})

//时间转换
Vue.filter('date', (date, format, isMoment) => {
  if (!date) return "--";
  if (date instanceof Date) {
    date = date.getTime();
  }
  if (!format) format = "yyyy-MM-dd HH:mm:ss";
  var tagNum = /^[0-9]*$/.test(date);
  if (!tagNum && date.indexOf("T") < 0) {
    date = date.replace(/-/g, "/");
  }
  if (tagNum || Date.parse(date)) {
    if (tagNum) date = parseInt(date);
    date = new Date(date).getTime();
    if (date.toString().length == 10) {
      date = date * 1000;
    }
    let offest = new Date().getTimezoneOffset();
    if (isMoment) date = date - offest * 1000 * 60;
    let datetime = dateFtt(format, date);
    return datetime;
  } else {
    return date;
  }
  /**************************************时间格式化处理************************************/
  function dateFtt(fmt, date) { //author: meizz   
    var date = new Date(date);
    var o = {
      "M+": date.getMonth() + 1, //月份   
      "d+": date.getDate(), //日   
      "H+": date.getHours(), //小时   
      "m+": date.getMinutes(), //分   
      "s+": date.getSeconds(), //秒   
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度   
      "S": date.getMilliseconds() //毫秒   
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  }

})

//depType
Vue.filter('week', (value) => {
  var arr = ["日", "一", "二", "三", "四", "五", "六"];
  var weekNum = 0;
  if (value) {
    weekNum = new Date(value).getDay();
  } else {
    weekNum = new Date().getDay();
  }
  return "星期" + arr[weekNum];
})

Vue.filter('weekNumber', (value) => {
  const date = value ? new Date(value) : new Date();
  const startOfYear = new Date(date.getFullYear(), 0, 1); // 获取年初
  const diff = date - startOfYear; // 日期差值
  const oneDay = 1000 * 60 * 60 * 24; // 一天的毫秒数
  const pastDays = Math.ceil(diff / oneDay); // 过去的天数
  return Math.ceil((pastDays + startOfYear.getDay() + 1) / 7); // 计算周数
})

Vue.filter('clamp', (value, fixed1 = 2, fixed2 = 2) => {
  value = value + "";
  if (value.length <= (Number(fixed1) || 0 + Number(fixed2) || 0 + 1)) {
    return value;
  }
  return value.slice(0, fixed1) + ".." + value.slice(-fixed2)
})

//depType
Vue.filter('depType', (value) => {
  var platform = "";
  switch (value) {
    case 1: platform = "行政部门"; break;
    case 2: platform = "教学部门"; break;
    default: platform = "其他";
  }
  return platform;
})


//arrstring
Vue.filter('arrstring', (arr, key, link) => {
  var str = "";
  arr.map((item, index) => {
    if (index < arr.length - 1 && item[key]) {
      str += item[key] + link;
    } else {
      str += item[key];
    }
  })
  return str;
})

//图片重置尺寸
Vue.filter('resize', (url, w, h) => {
  if (url.indexOf("x-oss-process=image") >= 0) {
    return `${url}/resize,w_${w},h_${h}`
  } else {
    return `${url}?x-oss-process=image/resize,w_${w},h_${h}`
  }
})

Vue.filter('fileView', (path, server) => {
  if (!path) {
    return "";
  }
  if (server == "own") {
    return 'http://47.115.75.110:8012/onlinePreview?url=' + Base64.encode(path);
  } else {
    let target = ['.doc', '.xls', '.ppt'].find(item => path.indexOf(item) > 0);
    if (target) {
      return "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(path);
    } else {
      return path;
    }
  }
})

Vue.filter('questionType', (type, tag) => {
  var name = "";
  type = Number(type);
  switch (type) {
    case 1: name = "单选"; break;
    case 2: name = "多选"; break;
    case 3: name = "判断"; break;
    case 4: name = "排序"; break;
    case 5: name = "填空"; break;
    case 6: name = "阅读"; break;
    case 7: name = "简答"; break;
    default: name = ""; break;
  }
  if (tag) {
    let excludeArr = ["单选选择", "多项选择"];
    if (tag.indexOf(name) >= 0 || excludeArr.indexOf(name) >= 0) {
      return tag;
    } else {
      return tag + "•" + name;
    }
  } else {
    return name;
  }
})

Vue.filter('schoolYear', val => {
  var name = "";
  switch (val) {
    case 1: name = "小学"; break;
    case 2: name = "初中"; break;
    case 3: name = "高中"; break;
    case 4: name = "中职"; break;
    default: name = "其他"; break;
  }
  return name;
})

Vue.filter('teachingType', val => {
  var name = "";
  switch (val) {
    case 1: name = "综合类"; break;
    case 2: name = "单招类"; break;
    case 3: name = "统招类"; break;
    case 4: name = "高考类"; break;
    default: name = "--"; break;
  }
  return name;
})

Vue.filter('classLevel', val => {
  var name = "";
  val = Number(val);
  switch (val) {
    case 11: name = "一年级"; break;
    case 12: name = "二年级"; break;
    case 13: name = "三年级"; break;
    case 14: name = "四年级"; break;
    case 15: name = "五年级"; break;
    case 16: name = "六年级"; break;
    case 31: name = "初一"; break;
    case 32: name = "初二"; break;
    case 33: name = "初三"; break;
    case 51: name = "普高(一)"; break;
    case 52: name = "普高(二)"; break;
    case 53: name = "普高(三)"; break;
    case 71: name = "职高(一)"; break;
    case 72: name = "职高(二)"; break;
    case 73: name = "职高(三)"; break;
    case 91: name = "大一"; break;
    case 92: name = "大二"; break;
    case 93: name = "大三"; break;
    case 94: name = "大四"; break;
    default: name = "默认"; break;
  }
  return name;
})

Vue.filter('reviewState', val => {
  var name = "";
  switch (val) {
    case 0: name = "未提交"; break;
    case 1: name = "未通过"; break;
    case 2: name = "已通过"; break;
    default: name = "--"; break;
  }
  return name;
})

Vue.filter('paperType', val => {
  var name = "";
  switch (val) {
    case 1: name = "职业认证"; break;
    case 2: name = "学习测验"; break;
    case 3: name = "岗位考试"; break;
    case 4: name = "知识点考试"; break;
    default: name = "其他"; break;
  }
  return name;
})

Vue.filter('paperLevel', val => {
  var name = "";
  switch (val) {
    case 1: name = "精品"; break;
    case 2: name = "标准"; break;
    case 3: name = "平常"; break;
    case 4: name = "一般"; break;
    default: name = "其他"; break;
  }
  return name;
})

Vue.filter('paperMode', val => {
  var name = "";
  switch (val) {
    case 0: name = "固定题目"; break;
    case 1: name = "随机题目"; break;
    case 2: name = "随机题量和题型"; break;
    default: name = "其他"; break;
  }
  return name;
})

Vue.filter('attestationType', val => {
  var name = "";
  switch (val) {
    case 1: name = "考试测验"; break;
    case 2: name = "知识认证"; break;
    case 5: name = "技能认证"; break;
    case 9: name = "岗位技能认证"; break;
    default: name = "考试测验"; break;
  }
  return name;
})

Vue.filter('capitalNumber', (val, suffix) => {
  var arr = [
    "一", "二", "三", "四", "五", "六", "七", "八", "九", "十",
    "十一", "十二", "十三", "十四", "十五", "十六", "十七", "十八", "十九", "二十",
  ];
  return arr[val - 1] + (suffix || "");
})

Vue.filter('taskType', val => {
  var name = "";
  switch (val) {
    case 1: name = "全案任务"; break;
    case 2: name = "分项任务"; break;
    case 3: name = "复盘任务"; break;
    default: name = "其他"; break;
  }
  return name;
})

Vue.filter('learnType', val => {
  val = Number(val);
  var name = "";
  switch (val) {
    case 10: name = "训练"; break;
    case 11: name = "错题强化"; break;
    case 12: name = "强化训练"; break;
    case 13: name = "提升训练"; break;
    case 20: name = "测验"; break;
    case 30: name = "考试"; break;
    default: name = "--"; break;
  }
  return name;
})

Vue.filter('tenantType', val => {
  var name = "";
  switch (val) {
    case 0: name = "企业"; break;
    case 1: name = "企业"; break;
    case 2: name = "学校"; break;
    case 3: name = "学校"; break;
    case 4: name = "学校"; break;
    case 5: name = "学校"; break;
    default: name = "单位"; break;
  }
  return name;
})

Vue.filter('tenantSort', val => {
  var name = "";
  switch (val) {
    case 1: name = "企业"; break;
    case 2: name = "中职"; break;
    case 3: name = "高职"; break;
    case 4: name = "专科"; break;
    case 5: name = "本科"; break;
    default: name = "单位"; break;
  }
  return name;
})

Vue.filter('jobType', val => {
  var name = "";
  switch (val) {
    case 1: name = "就业"; break;
    case 2: name = "实习"; break;
    case 3: name = "就业+实习"; break;
    case 4: name = "假期实践"; break;
    default: name = "--"; break;
  }
  return name;
})

Vue.filter('mutualType', val => {
  var name = "";
  switch (val) {
    case 1: name = "就业"; break;
    case 2: name = "实习"; break;
    case 3: name = "就业实习"; break;
    case 4: name = "假期实践"; break;
    default: name = "双选"; break;
  }
  return name;
})

Vue.filter('requireQualification', val => {
  var name = "";
  switch (val) {
    case 0: name = "学历不限"; break;
    case 1: name = "中专及以上"; break;
    case 2: name = "专科及以上"; break;
    case 3: name = "本科及以上"; break;
    default: name = "学历不限"; break;
  }
  return name;
})


Vue.filter('jobExperience', val => {
  var name = "";
  switch (val) {
    case 1: name = "1-3年"; break;
    case 3: name = "3-5年"; break;
    case 5: name = "5年以上"; break;
    default: name = "不限"; break;
  }
  return name;
})

Vue.filter('displayType', val => {
  var name = "";
  switch (val) {
    case 0: name = "私密"; break;
    case 1: name = "公开"; break;
    case 2: name = "粉丝"; break;
    case 3: name = "好友"; break;
    default: name = ""; break;
  }
  return name;
})

Vue.filter('tanantSort', val => {
  var name = "";
  switch (val) {
    case 1: name = "企业"; break;
    case 2: name = "中职"; break;
    case 3: name = "高职"; break;
    case 4: name = "专科"; break;
    case 5: name = "本科"; break;
    default: name = "单位"; break;
  }
  return name;
})


Vue.filter('tenantLevel', val => {
  var name = "";
  switch (val) {
    case 1: name = "普及版"; break;
    case 2: name = "标准版"; break;
    case 9: name = "管理级"; break;
    default: name = "未知"; break;
  }
  return name;
})


Vue.filter('learnLevel', val => {
  var name = "--";
  if (val >= 90) {
    name = "S";
  } else if (val >= 80) {
    name = "A+";
  } else if (val >= 70) {
    name = "A";
  } else if (val >= 60) {
    name = "A-";
  } else if (val >= 50) {
    name = "B+";
  } else if (val >= 40) {
    name = "B";
  } else if (val >= 30) {
    name = "B-";
  } else if (val >= 20) {
    name = "C+";
  } else if (val >= 10) {
    name = "C";
  } else if (val >= 0) {
    name = "D";
  }
  return name;
})

Vue.filter('costCycle', val => {
  var name = "";
  switch (val) {
    case 0: name = "学期"; break;
    case 1: name = "学年"; break;
  }
  return name;
})

Vue.filter('pakageWay', val => {
  var name = "";
  switch (val) {
    case 1: name = "综合型"; break;
    case 2: name = "学习型"; break;
    case 3: name = "测验型"; break;
    default: name = "综合型"; break;
  }
  return name;
})

Vue.filter('difficulty', val => {
  var name = "";
  if (val >= 7) {
    name = "高级难度";
  } else if (val >= 4) {
    name = "中等难度";
  } else {
    name = "基础难度";
  }
  return name;
})

Vue.filter('faculty', val => {
  var name = "";
  switch (val) {
    case 1: name = "单招"; break;
    case 2: name = "统招"; break;
  }
  return name;
})




// WEBPACK FOOTER //
// ./src/utils/filter.js